<template>
  <section>
    <pageHeader>3545 SPECIALTY PRODUCTS</pageHeader>
    <UnderLinedHeader class="pt-15 pb-8 white"
      >When You Need Custom Application or Appelt</UnderLinedHeader
    >
    <v-row align="center" class="pt-0 pb-16 pr-16 pl-16">
      <p class="artice-text text-center">
        3545 programmers can adapt what you have or rebuild it from scratch. We
        have developed specialty products for:<br /><br />
        <Strong style="font-family: Raleway">
          Firms and Legal Departments<br />
          Food and Beverage<br />
          Inventory Based Businesses<br />
          Accounting Firms<br />
          Long-term Care<br /><br />
        </Strong>
        Break free from the frustration of trying to make your enterprise
        software easier to use and more efficient. We can configure and optimize
        it to your specific needs! Amicus® Attorney provides comprehensive
        legal"
      </p>
    </v-row>
    <section>
      <v-row class="greyBG pb-16" style="margin-top: 6em">
        <v-col
          class="pa-16 mt-8"
          :class="$vuetify.breakpoint.smAndDown ? '' : 'pr-0'"
          justify="end"
          align="end"
          cols="12"
          s="12"
          xs="12"
          lg="6"
          xl="6"
          md="6"
        >
          <BPCarsoule />
        </v-col>
        <v-col cols="12" s="12" xs="12" lg="6" xl="6" md="6">
          <UnderLinedHeader
            align="left"
            class="pt-15 pb-8 "
            :class="$vuetify.breakpoint.smAndDown ? 'pl-4' : 'pl-16'"
            >Business Pulse®</UnderLinedHeader
          >
          <p
            class="text-justify artice-text"
            :class="$vuetify.breakpoint.smAndDown ? 'px-4' : 'px-16'"
          >
            Our product does things your way. Need a report or a mini
            application? Need real-time results reporting? Business Pulse® is
            just that. Start imagining:
          </p>
          <h4 :class="$vuetify.breakpoint.smAndDown ? 'pl-4' : 'pl-16'">
            Reporting
          </h4>
          <hoveredList
            :class="$vuetify.breakpoint.smAndDown ? 'pl-4' : 'pl-16'"
            :items="reportingList"
          />
          <h4
            class="pt-8"
            :class="$vuetify.breakpoint.smAndDown ? 'pl-4' : 'pl-16'"
          >
            Mini Applications – If You Can Imagine It, We Can Deliver It!
          </h4>
          <hoveredList
            :class="$vuetify.breakpoint.smAndDown ? 'pl-4' : 'pl-16'"
            :items="miniAppsList"
          />
        </v-col>
      </v-row>
    </section>
    <!-----------------------------END OF BPCarsoule----------------------->
    <v-row
      class="my-4"
      :class="$vuetify.breakpoint.smAndDown ? '' : 'mx-10 pa-4'"
      style="justify-content: start"
    >
      <v-col
        v-for="(item, index) in BP_Instalation"
        :key="index"
        class="colStyle"
        align="center"
        cols="12"
        s="12"
        xs="12"
        lg="4"
        xl="4"
        md="4"
      >
        <div
          class="my-4 py-4"
          :class="$vuetify.breakpoint.smAndDown ? 'px-4' : 'px-2'"
        >
          <div>
            <v-avatar class="mb-4" color="#a81e2d">
              <v-icon dark> mdi-download </v-icon>
            </v-avatar>
          </div>
          <div class="text-h6 spetHdr text-center" style="display: inline">
            {{ item.title }}
          </div>
          <div class="speContent">{{ item.content }}</div>
          <div><a class="downloadLink">DOWNLOAD</a></div>
        </div>
      </v-col>
    </v-row>
    <!-----------------------------END OF BP_Instalation----------------------->
    <v-row style="background-color: #f8f9f9 !important">
      <v-row
        class="mt-4"
        :class="$vuetify.breakpoint.smAndDown ? 'mx-4 pa-4' : 'mx-2 pa-4'"
      >
        <v-col
          align="center"
          cols="12"
          s="12"
          xs="12"
          lg="12"
          xl="12"
          md="12"
          v-for="(item, index) in special_product_details"
          :key="index"
        >
          <v-row
            :class="$vuetify.breakpoint.smAndDown ? 'mx-4 pa-4' : 'mx-10 pa-4'"
          >
            <v-col v-html="item.icon"></v-col>
            <v-col align="left">
              <v-container>
                <div class="text-h4 text-wrap Hdrstyle text-left pt-15">
                  {{ item.title }}
                </div>
                <hr />
                <div class="contentStyle" v-html="item.content"></div>
                <div><hoveredList class="listStyle" :items="item.list" /></div>
              </v-container>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-row>
    <!-----------------------------END OF special_product_details----------------------->
    <UnderLinedHeader
      align="center"
      class="pt-15 pb-8"
      style="background: white"
      :class="$vuetify.breakpoint.smAndDown ? 'pl-4' : ''"
      >Point-N-Show</UnderLinedHeader
    >
    <v-row align="center" class="pt-0 pb-16 pr-16 pl-16">
      <p class="artice-text text-center">
        An intuitive, easy to use Trial Presentation System. Point-N-Show is a
        small, stand-alone application that allows you to present images and
        digital media. It’s everything you need in court, and the power of
        pointing at your notes is in your hand. It is as simple as 1, 2, 3!
        Trial presentation does not have to be expensive or complicated. Let the
        developer show you how.
      </p></v-row
    >
    <v-row
      class="my-4"
      style="justify-content: start"
      :class="$vuetify.breakpoint.smAndDown ? '' : 'mx-10 pa-4'"
      justify="start"
    >
    <v-col
        class="colStyle"
        align="center"
        vertical-align="top"
        cols="12"
        s="12"
        xs="12"
        lg="4"
        xl="4"
        md="4"
      >
        <div
          class="my-4 py-4"
          :class="$vuetify.breakpoint.smAndDown ? 'px-4' : 'px-2'"
        >
          <div>
            <v-avatar class="mb-6"  color="#f8f9f9" size="150" >
              <v-avatar class="inner-circle" color="#a81e2d" size="120">
                <v-icon dark size="60" style="font-style: normal">
                  1.
                </v-icon>
              </v-avatar>
            </v-avatar>
            <v-icon style="right: -70px;"> mdi-arrow-right</v-icon>
          </div>
          
          <div
            class="mt-0 spetHdr text-center"
            justify="top"
            style="display: inline"
          >
            TELL POINT-N-SHOW WHERE YOUR FILES ARE LOCATED.
          </div>
          <div class="speContent mt-2">They can be on your local hard drive, a thumb drive, CD-ROM, even on a network. The only limitation is that they all reside in the same folder.</div>
        </div>
      </v-col>
    <v-col
        class="colStyle"
        align="center"
        vertical-align="top"
        cols="12"
        s="12"
        xs="12"
        lg="4"
        xl="4"
        md="4"
      >
        <div
          class="my-4 py-4"
          :class="$vuetify.breakpoint.smAndDown ? 'px-4' : 'px-2'"
        >
          <div>
            <v-avatar class="mb-6"  color="#f8f9f9" size="150" >
              <v-avatar class="inner-circle" color="#a81e2d" size="120">
                <v-icon dark size="60" style="font-style: normal">
                  2.
                </v-icon>
              </v-avatar>
            </v-avatar>
            <v-icon style="right: -70px;"> mdi-arrow-right</v-icon>
          </div>
          
          <div
            class="mt-0 spetHdr text-center"
            justify="top"
            style="display: inline"
          >
            WITH JUST A FEW CLICKS, PRINT THUMBNAILS OF YOUR FILES.
          </div>
          <div class="speContent  mt-2">ou can choose to print the thumbnails 3,6,9, or 12 images to a page (depending on how much detail you need). Point-N-Show also prints attorney notes for each image as desired AND automatically adds a barcode font to each image.</div>
        </div>
      </v-col>
    <v-col
        class="colStyle"
        align="center"
        vertical-align="top"
        cols="12"
        s="12"
        xs="12"
        lg="4"
        xl="4"
        md="4"
      >
        <div
          class="my-4 py-4"
          :class="$vuetify.breakpoint.smAndDown ? 'px-4' : 'px-2'"
        >
          <div>
            <v-avatar class="mb-6"  color="#f8f9f9" size="150" >
              <v-avatar  class="inner-circle" color="#a81e2d" size="120">
                <v-icon dark size="60" style="font-style: normal">
                  3.
                </v-icon>
              </v-avatar>
            </v-avatar>
          </div>
          
          <div
            class="mt-0  spetHdr text-center"
            justify="top"
            style="display: inline"
          >
            DISPLAY THE FILE YOU WANT WITH THE POINT-N-SHOW CORDLESS BARCODE SCANNER.
          </div>
          <div class="speContent mt-2">No longer do you have to fumble with a keyboard to navigate around in your slideshow. No more being dependant on staff to make sure the courtroom presentation goes well. You can also take as much digital data to court as you want, knowing that you will be able to access it easily and quickly. You’ve got your Point-N-Show!</div>
        </div>
      </v-col>
      <!--<v-col
        v-for="(item, index) in pointNSteps"
        :key="index"
        class="colStyle"
        align="center"
        vertical-align="top"
        cols="12"
        s="12"
        xs="12"
        lg="4"
        xl="4"
        md="4"
      >
        <div
          class="my-4 py-4"
          :class="$vuetify.breakpoint.smAndDown ? 'px-4' : 'px-2'"
        >
          <div>
            <v-avatar class="mb-6"  color="#f8f9f9" size="150" >
              <v-avatar  color="#a81e2d" size="120">
                <v-icon dark size="60" style="font-style: normal">
                  {{ item.num }}
                </v-icon>
              </v-avatar>
            </v-avatar>
            <v-icon> mdi-arrow-right</v-icon>
          </div>
          
          <div
            class="mt-0 spetHdr text-center"
            justify="top"
            style="display: inline"
          >
            {{ item.title }}
          </div>
          <div class="speContent">{{ item.content }}</div>
        </div>
      </v-col>-->
    </v-row>
    <!-----------------------------END OF pointNSteps----------------------->
    <v-row class="contactDiv mt-4 px-16" align="center">
      <v-col
        align="center"
        class="vcolRight"
        cols="12"
        s="12"
        xs="12"
        lg="6"
        xl="6"
        md="6"
      >
        <span class="" style="">
          Contact our engineering team to report an incident.</span
        >
      </v-col>
      <v-col
        align="center"
        class="vcolLeft pr-16"
        cols="12"
        s="12"
        xs="12"
        lg="6"
        xl="6"
        md="6"
      >
        <v-btn class="" outlined color="white"> CONTACT US</v-btn>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import ImageModel from "@/components/global/compnentsMixins/ImageModel.vue";
import BPCarsoule from "@/components/BusinessPulseAnalytics/BPCarsoule.vue";
import HoveredList from "@/components/global/compnentsMixins/HoveredList.vue";
import PageHeader from "@/components/global/compnentsMixins/PageHeader.vue";
import UnderLinedHeader from "@/components/global/compnentsMixins/UnderLinedHeader.vue";
import About from '../About.vue';
export default {
  components: {
    PageHeader,
    UnderLinedHeader,
    HoveredList,
    ImageModel,
    BPCarsoule,
    About,
  },
  data() {
    return {
      reportingList: [
        "Interactive Dashboards you design",
        "Real-time Reporting on any ODBC application",
        "Uses Microsoft’s SQL Server Reporting Services (SSRS)",
        "Sends results to Excel, Word, PDF or Email",
      ],
      miniAppsList: [
        "Add tables to store information your current program can’t",
        "Add features you need that your favorite application doesn’t understand",
        "Uses Microsoft’s SQL Server Reporting Services (SSRS)",
        "Take an off-the-shelf application such as QuickBooks and turn it into a specialized application for you",
      ],
      standardReportsList: [
        "Billing",
        "Receivables",
        "Budget Variance",
        "Receipt Allocation",
        "Productivity",
        "Transactions",
      ],
      BP_Instalation: [
        {
          title: "BusinessPulse® Installation Instructions",
          content: "",
          downloadFile: "",
        },
        {
          title: "BusinessPulse® Update",
          content:
            "After downloading, double-click to update your current copy of Business Pulse®. Replace the copy currently in the shared folder originally chosen for installation.",
          downloadFile: "",
        },
        {
          title: "Workstation Setup Instructions",
          content: "",
          downloadFile: "",
        },
      ],
      /*pointNSteps: [
        {
          num: "1.",
          rArrow:"<v-icon>mdi-arrow-right</v-icon>",
          title: "TELL POINT-N-SHOW WHERE YOUR FILES ARE LOCATED.",
          content:
            "They can be on your local hard drive, a thumb drive, CD-ROM, even on a network. The only limitation is that they all reside in the same folder.",
        },
        {
          num: "2.",
          rArrow:"",
          title: "WITH JUST A FEW CLICKS, PRINT THUMBNAILS OF YOUR FILES.",
          content:
            "You can choose to print the thumbnails 3,6,9, or 12 images to a page (depending on how much detail you need). Point-N-Show also prints attorney notes for each image as desired AND automatically adds a barcode font to each image.",
        },
        {
          num: "3.",
          rArrow:"",
          title:
            "DISPLAY THE FILE YOU WANT WITH THE POINT-N-SHOW CORDLESS BARCODE SCANNER.",
          content:
            "No longer do you have to fumble with a keyboard to navigate around in your slideshow. No more being dependant on staff to make sure the courtroom presentation goes well. You can also take as much digital data to court as you want, knowing that you will be able to access it easily and quickly. You’ve got your Point-N-Show!",
        },
      ],*/
      special_product_details: [
        {
          icon: '<img src="../img/Softwares/drop-trak-red-450x300.png" alt="services-cloud-red" width="450" height="300" style="vertical-align:middle;margin:0px 50px">',
          title: "Club Trak",
          content:
            'Club Trak tracks membership for Private Clubs. Member’s data is entered by swiping drivers license or other state issued ID’s, checks age & membership status, handles monthly meeting minutes & prints membership lists, and reports on expired memberships. Your data stays on your premises.<br /><br /> <b style= " font-family: Raleway">NO MONTHLY FEES!</b>',
        },
        {
          icon: '<img src="../img/Softwares/reader-1-350x321.png" alt="services-cloud-red" width="450" height="300" style="vertical-align:middle;margin:0px 50px">',
          title: "Customized Card Readers",
          content:
            "Use our programmed and customized card readers to help you accurately and quickly enter information into your database from any magnetic stripped card. Data can feed directly into Time Matters and other popular database programs.",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
p.artice-text {
  font-family: $primaryFontFamily;
  font-size: 1em;
  line-height: 24px;
}
hr {
  border-top: 2px solid #a81e2d;
  width: 60px;
  margin-top: 20px;
}
.container_background {
  background-color: #f9f9f9 !important;
}

.v-card {
  background-color: #f9f9f9 !important;
  margin-top: 20px;
  align-items: left;
}

.Hdrstyle {
  font-family: Poppins;
  letter-spacing: 0;
  color: #222;
  font-style: italic;
  font-weight: 700;
  margin-bottom: 24px;
}
.contentStyle {
  font-family: Raleway;
  font-style: normal;
  font-weight: 400;
  padding-top: 20px;
  font-size: 15px;
  line-height: 25px;
  color: #222;
}
.listStyle {
  color: #3d3935;
  font-size: 16px;
  line-height: 18px;
  font-family: open_sansregular;
  margin-bottom: 10px;
}
.spetHdr {
  font-family: Poppins;
  letter-spacing: 0;
  color: #222;
  font-style: italic;
  font-weight: 700;
  margin-bottom: 24px;
}
.speContent {
  font-family: Raleway;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 25px;
  color: #222;
}
.downloadLink {
  font-family: Raleway;
  color: #a81e2d;
  font-weight: 600;
  font-size: 12px;
}
.contactDiv {
  font-size: 26px;
  color: white;
  font-family: Tahoma, "Helvetica Neue", Helvetica, Arial, sans-serif;
  height: 150px;
  background: #a81e2d;
}
.inner-circle{
  i{
    color:#a81e2d !important; 
    &:hover{
    color:white !important;
  } 
  }
  background-color:white !important;
  &:hover{
    background-color:#a81e2d !important;
  }
}
</style>